/**
 * Get the CSP Nonce meta content attribute
 * @returns {string | undefined}
 */
export const getCspNonce = (): string | undefined => {
  return document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? undefined
}
